import styled from 'styled-components'
/* ${({ color }) => `color: ${color};`} */
export const Main = styled.main`
  height: 540px;
  overflow-y: scroll;
  margin-bottom: 30px;
  overflow-x: visible;
`
export const TableContainer = styled.table<{ multiplier?: any; grid?: string }>`
  width: 100%;
  tbody {
    overflow-x: hidden;
    margin-bottom: 30px;
  }
  th {
    font-size: 10px;
    text-align: left;
    padding-bottom: 10px;
  }
  thead {
    tr {
      display: grid;
      grid-template-columns: ${({ multiplier }) =>
        multiplier ? '70px 75px 70px 97px' : '30% 20% 50%'};
    }
  }
  .thUser {
    width: 68px;
  }
  .thPayout {
    width: ${({ multiplier }) => !multiplier && ' 35px'};
    text-align: ${({ multiplier }) => multiplier && 'center'};
    padding-right: ${({ multiplier }) => !multiplier && '15px'};
  }
  .thMP {
    text-align: center;
  }
  .thProfit {
    text-align: right;
  }
`
